module.exports = __webpack_public_path__ + "img/what5.18370422.png";